import React from "react";
import {graphql} from "react-apollo";
import get from "lodash/get";
import {Badge, InboxFilled, InboxLine, TimeSheetFilled, TimeSheetLine} from "@unibuddy/patron";
import HelpFilled from "react-icons/lib/io/ios-help";
import HelpLine from "react-icons/lib/io/ios-help-outline";
import {isFeatureEnabled} from "shared/Utils/FeatureUtils";
import {unreadCountQuery, unreadCountQueryOptions} from "shared/Inbox/queries/unreadCountQuery";
import MenuList from "../MenuList/MenuList";
import s from "./Navigation.pcss";
import NavLink from "./NavLink/NavLink";
import Content from "../Icons/Content";

const PrivateNavigation = ({me, unreadCount, university}) => {
    const role = me.anyUser.accountRole;
    const user = me[role];
    const profilePhotoUrl = get(user, "profilePhoto");
    const isMentor = role === "mentor";

    return (
        <React.Fragment>
            <NavLink
                className={s.inbox}
                to="/inbox"
                icon={({isActive}) =>
                    isActive ? <InboxFilled/> : <InboxLine/>
                }
            >
                {unreadCount > 0 && (
                    <Badge
                        className={s.badge}
                        color="danger"
                        aria-label={`${unreadCount} new messages`}
                    >
                        {unreadCount}
                    </Badge>
                )}
                Inbox
            </NavLink>
            {isFeatureEnabled("userGeneratedContent", university)
            && <NavLink
                id="blog-tab"
                to={`/blog`}
                icon={() => <Content/>}
            >
                Content
            </NavLink>}
            {isMentor && isFeatureEnabled("buddiesSavedAnswer", university) && (
                <NavLink
                    to="/saved-answers"
                    icon={({isActive}) =>
                        isActive ? <HelpFilled/> : <HelpLine/>
                    }
                >
                    Answers
                </NavLink>
            )}
            {isMentor && (
                <NavLink
                    to="/time-sheet"
                    icon={({isActive}) =>
                        isActive ? <TimeSheetFilled/> : <TimeSheetLine/>
                    }
                >
                    Time Sheet
                </NavLink>
            )}
            <MenuList
                className={s.settings}
                profilePhotoUrl={profilePhotoUrl}
            />
        </React.Fragment>
    );
};

export default graphql(
    unreadCountQuery,
    unreadCountQueryOptions,
)(PrivateNavigation);
